/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandartProductConversionFieldDto } from '../../models/backend-standart-product-conversion-field-dto';
import { BackendStandartProductConversionFieldRequestDto } from '../../models/backend-standart-product-conversion-field-request-dto';

export interface SalesStandardProductConversionFieldsCreate$FormData$Params {
  body: BackendStandartProductConversionFieldRequestDto;
}

export function salesStandardProductConversionFieldsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductConversionFieldsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductConversionFieldsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandartProductConversionFieldDto>;
    }),
  );
}

salesStandardProductConversionFieldsCreate$FormData.PATH = '/api/sales/standard-product-conversion-fields/';
